// Common utility constants
export const API_ENDPOINTS = {
  LOGIN: "/login",
  REGISTER: "/register",
  LOGOUT: "/logout",
  REFRESH_TOKEN: "/refresh-token",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  LISTINGS: "/listings",
  BRANDS: "/listings/brands",
  FILTERS: "/listings/filters",
} as const;

export const STORAGE_KEYS = {
  USER: "user",
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
} as const;

export const FORM_TYPES = {
  LOGIN: "login",
  REGISTER: "register",
  FORGOT_PASSWORD: "forgot-password",
} as const;

export const EVENT_TYPES = {
  CLICK_GO_TO_VENDOR_LISTING: "click_go_to_vendor_listing",
  CLICK_LISTING_CARD: "click_listing_card",
  FAVORITE_ADDED: "favorite_added",
  FAVORITE_REMOVED: "favorite_removed",
  LOGIN: "login",
  LOGOUT: "logout",
  NOTIFY_ADDED: "notify_added",
  NOTIFY_REMOVED: "notify_removed",
  REGISTER: "register",
  SEARCH: "search",
  UPDATE_USER: "update_user",
  LISTING_IMPRESSION: "listing_impression",
  IMPRESSION_TRACKING_ERROR: "impression_tracking_error",
} as const;

export const DEFAULT_SORT_KEY = "deal_best";
export const SORT_OPTIONS = [
  { value: DEFAULT_SORT_KEY, label: "Deal: Best to Worst" },
  { value: "latest", label: "Latest Arrivals" },
  { value: "price_lowest", label: "Price: Low to High" },
  { value: "price_highest", label: "Price: High to Low" },
  { value: "trending", label: "Trending" },
] as const;

export const SORT_LATEST = "latest";

export const COLOR_OPTIONS = [
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "pink", label: "Pink" },
  { value: "grey", label: "Grey" },
  { value: "black", label: "Black" },
  { value: "brown", label: "Brown" },
  { value: "white", label: "White" },
  { value: "neutrals", label: "Neutral" },
] as const;

export const HARDWARE_OPTIONS = [
  { value: "black", label: "Black" },
  { value: "brass", label: "Brass" },
  { value: "crystal", label: "Crystal" },
  { value: "gold", label: "Gold" },
  { value: "gunmetal", label: "Gunmetal" },
  { value: "mixed", label: "Mixed" },
  { value: "none", label: "None" },
  { value: "other", label: "Other" },
  { value: "palladium", label: "Palladium" },
  { value: "permabrass", label: "Permabrass" },
  { value: "rose gold", label: "Rose Gold" },
  { value: "ruthenium", label: "Ruthenium" },
  { value: "silver", label: "Silver" },
] as const;

export const DEAL_OPTIONS = [
  { value: "great", label: "Great" },
  { value: "good", label: "Good" },
  { value: "fair", label: "Fair" },
  { value: "poor", label: "Poor" },
  { value: "bad", label: "Bad" },
] as const;

export const CONDITION_OPTIONS = [
  { value: "pristine", label: "Pristine" },
  { value: "excellent", label: "Excellent" },
  { value: "very_good", label: "Very Good" },
  { value: "good", label: "Good" },
  { value: "fair", label: "Fair" },
  { value: "poor", label: "Poor" },
] as const;

export const CONDITION_INT_TO_NAME = {
  1: "Pristine",
  2: "Excellent",
  3: "Very Good",
  4: "Good",
  5: "Fair",
  6: "Poor",
} as const;

export const VENDOR_OPTIONS = [
  { value: "farfetch", label: "Farfetch" },
  { value: "fashionphile", label: "Fashionphile" },
  { value: "mygemma", label: "MyGemma" },
  { value: "rebag", label: "ReBag" },
  { value: "the realreal", label: "The RealReal" },
] as const;
